export const INTERNAL_THEME = {
    COMPASS_BASE_SIMULATOR: "COMPASS_BASE_SIMULATOR",
    COMPASS_ONE_MINUTE_SIMULATOR: "COMPASS_ONE_MINUTE_SIMULATOR"
};

export const PAGES = {
    BASENAME: "/simulatore",
    SIMULATORE_STANDARD_HOME: "/simulatore-commerciale.html",
    SIMULATORE_ONE_MINUTE_HOME: "/simulatore-commerciale-1-minuto.html",
    RECAP: "/risultato-profilo-web.html",
    DATI_UTENTE: "/dati-utente.html",
    CONFERMA_OTP: "/conferma-otp.html",
    OFFLINE: "/offline.html"
};

export const SIMULATOR_TYPES = {
    COMPASS_BASE_SIMULATOR: "COMPASS-SIMULATORE-STANDARD",
    COMPASS_ONE_MINUTE_SIMULATOR: "COMPASS-SIMULATORE-1-MINUTO",
};